/**
 * UnauthorizedPage Component
 * Displayed when user tries to access a page without proper permissions
 */

import React from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './UnauthorizedPage.css';

/**
 * UnauthorizedPage - Access denied page
 * @returns {JSX.Element} UnauthorizedPage component
 */
const UnauthorizedPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/messages');
  };

  return (
    <Container className="unauthorized-page">
      <div className="unauthorized-content">
        <div className="unauthorized-icon">
          <FontAwesomeIcon icon={faExclamationTriangle} size="4x" />
        </div>
        
        <Alert variant="danger" className="unauthorized-alert">
          <Alert.Heading>Access Denied</Alert.Heading>
          <p>
            You do not have permission to access this page. 
            Administrator privileges are required.
          </p>
          <hr />
          <p className="mb-0">
            If you believe you should have access to this page, 
            please contact your system administrator.
          </p>
        </Alert>

        <Button 
          variant="primary" 
          onClick={handleGoBack}
          className="mt-3"
        >
          <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
          Return to Messages
        </Button>
      </div>
    </Container>
  );
};

export default UnauthorizedPage;
